module.exports = __webpack_public_path__ + "static/media/spirited_away-back.490d369b.jpg";